// extracted by mini-css-extract-plugin
export default {"h2":"textes_h2__33Ytb","p":"textes_p__GSvtc"};